<template>
  <div>
    <activeinventory
      :activeinventory="activeInventory"
      :allactiveinventory="allActiveInventory"
      :devicemakemodels="deviceMakeModels"
      :tableloading="tableLoading"
      :key="key"
    ></activeinventory>
  </div>
</template>

<script>
import Api from "@/services/Api";
import ActiveInventory from "@/components/ActiveInventory.vue";

export default {
  components: {
    activeinventory: ActiveInventory
  },
  data() {
    return {
      activeInventory: [],
      allActiveInventory: [],
      deviceMakeModels: [],
      tableLoading: true,
      key: 0
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.getActiveInventory();
      this.getDeviceMakeModels();
    },
    getActiveInventory() {
      Api()
        .get("/devices/inventory")
        .then(response => {
          this.allActiveInventory = response.data;
          var helper = {};
          var result = response.data.reduce(function(r, o) {
            var key = o.deviceMakeModelId;
            if (!helper[key]) {
              helper[key] = Object.assign({}, o);
              if (o.isActive && !o.isDeleted) {
                helper[key].count = 1;
                if (!o.inStock) {
                  helper[key].activeCount = 1;
                  helper[key].stockCount = 0;
                } else {
                  helper[key].activeCount = 0;
                  helper[key].stockCount = 1;
                }
                r.push(helper[key]);
              }
            } else {
              if (o.isActive && !o.isDeleted) {
                helper[key].count += 1;
                if (!o.inStock) {
                  helper[key].activeCount += 1;
                } else {
                  helper[key].stockCount += 1;
                }
              }
            }
            return r;
          }, []);
          this.activeInventory = result;
          this.tableLoading = false;
          this.key += 1;
        });
    },
    getDeviceMakeModels() {
      Api()
        .get("/deviceMakeModels")
        .then(response => {
          this.deviceMakeModels = response.data;
        });
    }
  }
};
</script>

<style>
</style>